import { API, BASE_URL } from '../../constants/urls';

export async function getInviteLink(listingAlias: string): Promise<string> {
  const applicationLink = `https://${window.location.host}/renter-hub/applications/listing/${listingAlias}/rental-application?utm_source=applicationshare&utm_medium=desktopmweb&utm_campaign=applicationlinkshare`;
  const requestUrl = `${BASE_URL}${API.GET_INVITE_LINK}?listingAlias=${listingAlias}`;
  const response = await fetch(requestUrl, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      listingAlias,
      applicationLink,
    }),
  });
  const responseBody = await response.json();
  return responseBody?.response;
}
